@for (field of properties; track $index) {
    <div class="row table-like">
        <span class="col-3 text-break d-flex align-items-center justify-content-start">{{field.name}}</span>
        <div class="col-9 d-flex align-items-center pe-0">
            <span class="text-break flex-grow-1">{{field.value}}</span>
            @if (showOptions) {
                <button mat-icon-button (click)="onEvent.next({ field: {name: field.name, value: field.value}, event: $event })">
                    <mat-icon>more_vert</mat-icon>
                </button>
            }
        </div>
    </div>
}
